// eslint-disable-next-line
export default "https://test-grupni.herokuapp.com";
